import { instance as axios, setJwtToken, setMultiPartHeader } from "../../config/axiosInstance"

//---------------------faq-listing------------------------------
export const fathFaqApi = async (data) => {
    const endPoint = `/faq/list` + `?` + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken())
}

//--------------------add-faq-------------------------------
export const addFaqApi = async (data) => {
    const endPoint = `/faq/add`
    return await axios.post(endPoint, data, setMultiPartHeader())
}

// //--------------------status-faq-------------------------------
export const changeStatusFaqAPi = async (data) => {
    const endPoint = `/faq/change_status`
    return await axios.put(endPoint, data, setMultiPartHeader())
}
//--------------------update-faq-------------------------------
export const updateFaqApi = async (id, data) => {
    const endPoint = `/faq/update/${id}`
    return await axios.put(endPoint, data, setMultiPartHeader())
}

//--------------------faq-details-------------------------------
export const faqDetailsApi = async (id) => {
    const endPoint = `/faq/view/${id}`
    return await axios.get(endPoint, setJwtToken())
}
//-------------------delete-faq-----------------------
export const deleteFaqApi = async (id) => {
    return await axios.delete(`/faq/delete/${id}`, setJwtToken())
}